import {TypeTab, TypeWrapper} from "../../styles/TradeStyles";
import Text from "../../utils/Text";
import {FlexCenter, Margin} from "../../styles/CommonStyles";
import TradeType from "../tradespot/TradeType";
import useTradingSpot from "../../hooks/useTradingSpot";
import {RTradeCompWrap} from "../../styles/responsive/CommonStyles";
import ModalLayout from "../../layouts/ModalLayout";
import Invoice from "../common/invoice/Invoice";
import FilterDropdown from "../../modals/FilterDropdown";


const RTradingComp = () => {

    const {
        activeTab, activeType,
        setActiveTab, setActiveType,
        buyInput, setBuyInput,
        sellInput, setSellInput,
        onOperationClicked,
        invoice, onInvoiceClosed,
        validTrade, ocoError
    } = useTradingSpot()


    return(
        <>
            <RTradeCompWrap>
                <FlexCenter>
                    <TypeWrapper>
                        {types.map(type => (
                            <TypeTab
                                key={type}
                                active={activeType === type}
                                type={type}
                                onClick={() => setActiveType(type)}
                            >
                                <Text tid={type} />
                            </TypeTab>
                        ))}
                    </TypeWrapper>
                </FlexCenter>
                <Margin margin="10px 0" />
                <FlexCenter>
                    <FilterDropdown
                        defaultOption={0}
                        options={tabs}
                        onOptionChanged={(idx) => setActiveTab(idx)}
                        width="100%"
                    />
                </FlexCenter>
                <Margin margin="5px 0"/>
                <TradeType
                    type={activeType}
                    activeTab={activeTab}
                    userInput={activeType === "buy" ? buyInput : sellInput}
                    setUserInput={activeType === "buy" ? setBuyInput : setSellInput}
                    onOperationClicked={(limitsError, limits) => onOperationClicked(activeType, limitsError, limits)}
                    valid={validTrade[activeType]}
                    ocoError={ocoError}
                />
            </RTradeCompWrap>
            <ModalLayout
                open={invoice.visible}
                onClose={onInvoiceClosed}
                minWidth="300px"
                width="90%"
            >
                <Invoice
                    data={invoice.type === "buy" ? buyInput : sellInput}
                    type={invoice.type}
                    tab={activeTab}
                    onClose={onInvoiceClosed}
                />
            </ModalLayout>
        </>
    )
}

const types = [
    "buy", "sell"
]

const tabs = [
    "Limit", "Market", "Stop limit", "Oco"
]


export default RTradingComp;
